import React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';

import {
    fetchSocialActionsByObjective,
    fetchSocialAdSetsByObjective,
    fetchSocialDataByObjective,
    fetchSocialCampaignsByObjective,
    fetchSocialUniqueMeasuresByObjective,
} from 'services/social/duck';
import { shouldShowTotalActivities } from 'helpers/data';

import { SocialObjectiveDashboardComponent } from 'containers/dashboards/DashboardBaseComponent';
import ReachExpandModule from 'components/organisms/social/ReachExpandModule';

class ReachExpandContainer extends SocialObjectiveDashboardComponent {
    constructor(props, { objective = 'REACH' } = {}) {
        super(props, objective);
    }

    makeRequestsForData() {
        const entityId = this.getCurrentEntityId();
        const objective = this.getCurrentObjective();
        const payload = this.createPayload(entityId, objective);

        this.props.fetchSocialActionsByObjective(payload);
        this.props.fetchSocialAdSetsByObjective(payload);
        this.props.fetchSocialCampaignsByObjective(payload);
        this.props.fetchSocialDataByObjective(payload);
        this.props.fetchSocialUniqueMeasuresByObjective({
            ...payload,
            grain: 'adset'
        });
    }

    render() {
        const { hide, showConversionRevenue, showSemCpconv } = this.props;
        return (
            !hide ?
                <ReachExpandModule module={this.props.module}
                    xAxisLabel={this.props.xAxisLabel}
                    backfillBuckets={this.props.backfillBuckets}
                    objective={this.getCurrentObjective()}
                    layer={this.props.layer}
                    layerTwo={this.props.layerTwo}
                    showSemCpconv={showSemCpconv}
                    showConversionRevenue={showConversionRevenue}
                    entityMeta={this.props.entityMeta}
                    entityObjective={this.props.entityObjective}
                    entityObjectiveLabelCode={this.props.entityObjectiveLabelCode}
                /> : null
        );
    }
}

const mapDispatchPops = {
    fetchSocialActionsByObjective,
    fetchSocialAdSetsByObjective,
    fetchSocialDataByObjective,
    fetchSocialCampaignsByObjective,
    fetchSocialUniqueMeasuresByObjective,
};

const mapReachStateToProps = state => ({
    entityId: state.entities.meta.id,
    entityMeta: state.entities.meta,
    layerTwo: state.layerTwo,
    module: state.social.facebook.objectives.REACH,
    selectedTimeRange: state.config.selectedTimeRange,
    xAxisLabel: get(state, 'config.timeBuckets.config.xAxisLabel', 'Date'),
    backfillBuckets: get(state, 'config.timeBuckets.config.buckets', []),
    showSemCpconv: get(state, 'entities.meta.meta.showSemCpconv', false),
    showConversionRevenue: get(state, 'entities.meta.meta.showConversionRevenue', false),
    entityObjective: get(state, 'entities.meta.meta.programmaticObjective.global', 'ecpa'),
    entityObjectiveLabelCode: get(state, 'entities.meta.meta.programmaticObjective.labelCode', null),
});

export default connect(mapReachStateToProps, mapDispatchPops)(ReachExpandContainer);


class BrandAwarnessExpand extends ReachExpandContainer {
    constructor(props) {
        super(props, { objective: 'BRAND_AWARENESS' });
    }
}

const mapBrandAwarnessStateToProps = state => ({
    entityId: state.entities.meta.id,
    entityMeta: state.entities.meta,
    module: state.social.facebook.objectives.BRAND_AWARENESS,
    layerTwo: state.layerTwo,
    showTotalActivities: shouldShowTotalActivities(state),
    selectedTimeRange: state.config.selectedTimeRange,
    xAxisLabel: get(state, 'config.timeBuckets.config.xAxisLabel', 'Date'),
    backfillBuckets: get(state, 'config.timeBuckets.config.buckets', []),
    entityObjective: get(state, 'entities.meta.meta.programmaticObjective.global', 'ecpa'),
    entityObjectiveLabelCode: get(state, 'entities.meta.meta.programmaticObjective.labelCode', null),
});

export const BrandAwarnessExpandContainer = connect(mapBrandAwarnessStateToProps, mapDispatchPops)(BrandAwarnessExpand);



// WEBPACK FOOTER //
// ./src/containers/dashboards/social/ReachExpandContainer.js